










































































import Vue from "vue";
import Component from "vue-class-component";
import { RiskProfileRequestDto } from "@/api/ClientPortalApiClient";
import { RiskProfileStore, UserStore } from "@/store";
import router, { ROUTES } from "@/router";
import moment from "moment";

@Component({ name: "risk-profile-widget" })
export default class RiskProfileWidget extends Vue {
  private modalDisclaimer: string = "modal-disclaimer";

  requests: RiskProfileRequestDto[] = [];

  async created() {
    if (UserStore.loggedInUser) {
      await RiskProfileStore.LoadRequests();
      this.requests = RiskProfileStore.Requests;
    }
  }

  openProfile(request: RiskProfileRequestDto) {
    RiskProfileStore.SetSelectedRequest(request.id);

    // If not started, show disclaimer
    if (
      request.riskProfileType === "CLARUS" &&
      moment(request.completedDate) < moment(request.sentDate) &&
      RiskProfileStore.AllResponses.filter(x => x.requestId == request.id)
        .length === 0
    ) {
      this.$bvModal.show(this.modalDisclaimer);
    } else {
      this.goToRiskProfile();
    }
  }

  getStatus(request: RiskProfileRequestDto): string {
    if (moment(request.completedDate) > moment(request.sentDate)) {
      return "Completed";
    }

    if (
      RiskProfileStore.AllResponses.filter(x => x.requestId == request.id)
        .length > 0
    ) {
      return "In Progress";
    }

    return "Not Started";
  }

  getButtonActon(request: RiskProfileRequestDto): string {
    if (moment(request.completedDate) > moment(request.sentDate)) {
      return "View Result";
    }

    if (
      RiskProfileStore.AllResponses.filter(x => x.requestId == request.id)
        .length > 0
    ) {
      return "Resume";
    }

    return "Start";
  }

  disclaimerAgree() {
    this.$bvModal.hide(this.modalDisclaimer);
    this.goToRiskProfile();
  }

  disclaimerDontAgree() {
    this.$bvModal.hide(this.modalDisclaimer);
  }

  goToRiskProfile() {
    if (RiskProfileStore.ProfileIsComplete) {
      router.push({ name: ROUTES.riskprofilerresults });
    } else {
      router.push({ name: ROUTES.riskprofiler });
    }
  }
}
